import { useState } from "react";
import { C } from "../../shared/theme";
import { hue } from "../../shared/hue";
import { Sortable, DragHandle } from "../../shared/Sortable";
import { PLAN_ITEM_KINDS } from "./planItems";
import { photoRatio } from "./mosaic";

// Wraps one dream so it can be dragged by its ⠿ handle (never by the whole card).
// children(handle) gets a function that draws the handle, labelled with the item's title. `style` adds to the wrapper
// (Names gives a row a background, so the one being dragged doesn't show the rows under it).
export function SortablePlanItem({ id, style, children }) {
  return (
    <Sortable id={id} style={{ position: "relative", ...style }}>
      {({ isDragging, attributes, listeners, setActivatorNodeRef }) => (
        <div style={{ opacity: isDragging ? 0.85 : 1 }}>
          {children((label) => <DragHandle label={label} attributes={attributes} listeners={listeners} setActivatorNodeRef={setActivatorNodeRef} />)}
        </div>
      )}
    </Sortable>
  );
}

const STAR = <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />;

// A dream on the Dreamboard: its photo, or a soft wash with a star when it has none, its title, and `footer` under it
// (its tasks).
// `ownShape` is the mosaic's: the photo keeps its own shape (photoRatio) instead of 4:3.
export function DreamCard({ item, handle, onOpen, footer = null, ownShape = false }) {
  const h = hue(PLAN_ITEM_KINDS.dreams.hueName);
  const [ratio, setRatio] = useState(4 / 3);
  return (
    <div style={{ boxSizing: "border-box", borderRadius: C.r, overflow: "hidden", background: C.surface, border: `1px solid ${C.border}`, display: "flex", flexDirection: "column" }}>
      {/* Tapping the photo opens the dream too; keyboards and screen readers use the title button below. */}
      <div onClick={onOpen}
        style={{ width: "100%", background: h.w, cursor: "pointer", aspectRatio: ownShape ? String(ratio) : "4 / 3" }}>
        {item.image
          ? <img src={item.image} alt="" onLoad={(e) => setRatio(photoRatio(e.currentTarget.naturalWidth, e.currentTarget.naturalHeight))}
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          : (
            <span style={{ display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center", color: h.c }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{STAR}</svg>
            </span>
          )}
      </div>
      <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 4, padding: "4px 4px 4px 14px" }}>
        <button onClick={onOpen}
          style={{ flex: 1, minWidth: 0, textAlign: "left", background: "none", border: "none", padding: "8px 0", cursor: "pointer", fontFamily: "inherit", fontSize: 16, fontWeight: 700, lineHeight: 1.3, color: C.text }}>
          {item.title}
        </button>
        {handle(item.title)}
      </div>
      {footer}
    </div>
  );
}
